import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getCalendarEventDetailsStore } from '../store/calendarEventDetailsStore';
import { isEqual } from 'owa-datetime';

/**
 * Check if the event matches the last cached event
 */
export default function areEventDetailsFetched(
    event: CalendarEvent,
    fetchSeriesMaster: boolean
): boolean {
    const cachedEvent = getCalendarEventDetailsStore().calendarEvent;
    if (!cachedEvent || !getCalendarEventDetailsStore().eventDetailsFetched || fetchSeriesMaster) {
        return false;
    }

    // For occurrence/exception of the series, check the Start/End time and CalendarItemType besides the Id
    return (
        event.ItemId.Id === cachedEvent.ItemId.Id &&
        event.CalendarItemType === cachedEvent.CalendarItemType &&
        isEqual(event.Start, cachedEvent.Start) &&
        isEqual(event.End, cachedEvent.End)
    );
}
